export default __webpack_public_path__ + "static/media/Will Make Fine Silk.30ccaa21.png";